<div>
    <div class="row">
        <div class="column">
            <mm-from-account-details-condensed [subtitle]="subtitle"></mm-from-account-details-condensed>
        </div>
        <div class="column">
            <mm-receiving-account-details-it-condensed></mm-receiving-account-details-it-condensed>
        </div>
    </div>
    <mm-transaction-details-it-condensed></mm-transaction-details-it-condensed>
    <mm-twe-details-section *ngIf="isIra" [transactionType]="it" data-testid="twe-details-it">
    </mm-twe-details-section>
    <mm-ptrs-details-condensed data-testid="ptrs-details-it"></mm-ptrs-details-condensed>
</div>